import moment from 'moment'
import React from 'react'
import Calendar from 'react-calendar'
import './styles/styles.scss'

interface SingleDateSelectionProps {
  selectedDate: Date | undefined
  setSelectedDate: any
  startFrom?: Date
  endTo?: Date
}

const SingleDateSelection: React.FC<SingleDateSelectionProps> = ({
  selectedDate,
  setSelectedDate,
  startFrom,
  endTo,
}) => {
  const availableDates: string[] = []
  if (startFrom && endTo) {
    let current = moment(startFrom)
    const last = moment(endTo)
    while (current.isSameOrBefore(last, 'day')) {
      availableDates.push(current.format('YYYY-MM-DD'))
      current = current.add(1, 'day')
    }
  }

  return (
    <div className="schedule-calendar">
      <Calendar
        calendarType="US"
        onChange={setSelectedDate}
        defaultActiveStartDate={selectedDate}
        minDetail="month"
        minDate={startFrom && moment(startFrom, 'YYYY-MM-DD').toDate()}
        maxDate={endTo && moment(endTo, 'YYYY-MM-DD').toDate()}
        // tileDisabled={({ date }) => {
        //   if (startFrom && endTo) {
        //     return !availableDates.includes(moment(date).format('YYYY-MM-DD'))
        //   }
        //   return false
        // }}

        tileDisabled={({ date }) => {
          if (startFrom && endTo) {
            // ✅ disable outside the range
            return !availableDates.includes(moment(date).format('YYYY-MM-DD'))
          }
          // ✅ Case 2: only startFrom → disable dates before it
          if (startFrom && !endTo) {
            return moment(date).isBefore(moment(startFrom), 'day')
          }
          // ✅ Case 3: only endTo → disable dates after it
          if (!startFrom && endTo) {
            return moment(date).isAfter(moment(endTo), 'day')
          }
          // ✅ Case 4: none → no restriction
          return false
        }}
        // tileClassName={({ date }) => {
        //   let classes: string[] = []
        //   if (
        //     (!startFrom && !endTo) ||
        //     availableDates.includes(moment(date).format('YYYY-MM-DD'))
        //   ) {
        //     classes.push('availalbe-date')
        //   }
        //   if (
        //     selectedDate &&
        //     moment(selectedDate).format('YYYY-MM-DD') ===
        //       moment(date).format('YYYY-MM-DD')
        //   ) {
        //     classes.push('current-selected')
        //   }
        //   return classes.join(' ')
        // }}
        tileClassName={({ date }) => {
          let classes: string[] = []
          if (
            (!startFrom && !endTo) || // Case 4
            (startFrom &&
              endTo &&
              availableDates.includes(moment(date).format('YYYY-MM-DD'))) ||
            (startFrom &&
              !endTo &&
              moment(date).isSameOrAfter(moment(startFrom), 'day')) ||
            (!startFrom &&
              endTo &&
              moment(date).isSameOrBefore(moment(endTo), 'day'))
          ) {
            classes.push('availalbe-date')
          }

          if (
            selectedDate &&
            moment(selectedDate).format('YYYY-MM-DD') ===
              moment(date).format('YYYY-MM-DD')
          ) {
            classes.push('current-selected')
          }

          return classes.join(' ')
        }}
      />
    </div>
  )
}

export default SingleDateSelection
